import { render, staticRenderFns } from "./TrophyCase.vue?vue&type=template&id=3f45c4c2&scoped=true&"
import script from "./TrophyCase.vue?vue&type=script&lang=js&"
export * from "./TrophyCase.vue?vue&type=script&lang=js&"
import style0 from "./TrophyCase.vue?vue&type=style&index=0&id=3f45c4c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f45c4c2",
  null
  
)

export default component.exports